export default {
      id: "camera-usage",
      viewBox: "0 0 37 32",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#camera",
      toString: function () {
        return this.url;
      }
    }